// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var VWAPHistoryStatus;
(function (VWAPHistoryStatus) {
    VWAPHistoryStatus[VWAPHistoryStatus["Invalid"] = -1] = "Invalid";
    VWAPHistoryStatus[VWAPHistoryStatus["None"] = 0] = "None";
    VWAPHistoryStatus[VWAPHistoryStatus["Loading"] = 1] = "Loading";
    VWAPHistoryStatus[VWAPHistoryStatus["Processed"] = 2] = "Processed";
})(VWAPHistoryStatus || (VWAPHistoryStatus = {}));
